"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AboutModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lucide_1 = require("lucide");
const global_1 = require("@/common/global");
const i18n_1 = require("@/common/i18n");
const modal_1 = require("./modal");
class AboutModal extends modal_1.Modal {
    constructor(target) {
        super(target, { id: "about", title: (0, i18n_1.$)("modal.about.title"), icon: lucide_1.Info });
        this._addFooterButton("donate", {
            text: (0, i18n_1.$)("modal.about.ctx.donate"),
            variant: "primary",
            icon: lucide_1.HandCoins,
            contextMenuItems: [
                {
                    text: (0, i18n_1.$)("modal.about.ctx.donate"),
                    icon: lucide_1.HandCoins,
                    action: () => window.open("https://github.com/sponsors/nocpiun", "_blank")
                },
                { separator: true },
                {
                    text: (0, i18n_1.$)("modal.about.ctx.donate.links"),
                    subItems: [
                        {
                            text: (0, i18n_1.$)("modal.about.ctx.donate.links.repo"),
                            icon: lucide_1.SquareArrowOutUpRight,
                            action: () => window.open("https://github.com/nocpiun/motive", "_blank")
                        },
                        {
                            text: (0, i18n_1.$)("modal.about.ctx.donate.links.homepage"),
                            icon: lucide_1.SquareArrowOutUpRight,
                            action: () => window.open("https://github.com/NriotHrreion", "_blank")
                        },
                        {
                            text: (0, i18n_1.$)("modal.about.ctx.donate.links.website"),
                            icon: lucide_1.SquareArrowOutUpRight,
                            action: () => window.open("https://nocp.space", "_blank")
                        }
                    ]
                }
            ]
        }, "left", () => {
            window.open("https://nocp.space/donate", "_blank");
        });
        this._addFooterButton("changelog", { text: (0, i18n_1.$)("modal.about.changelog"), variant: "secondary", icon: lucide_1.BookMarked });
        // UI
        this._container.appendChild((0, jsx_runtime_1.jsxs)("div", { className: "basic-info-container", children: [(0, jsx_runtime_1.jsxs)("div", { className: "title-container", children: [(0, jsx_runtime_1.jsx)("h2", { children: (0, i18n_1.$)("app.name") }), (0, jsx_runtime_1.jsxs)("span", { className: "version-number", children: ["v", global_1.version] })] }), (0, jsx_runtime_1.jsx)("div", { className: "copyright-container", children: (0, jsx_runtime_1.jsxs)("span", { children: ["By Nocpiun Org / Copyright (c) ", new Date().getFullYear(), " NriotHrreion"] }) })] }));
        this._container.appendChild((0, jsx_runtime_1.jsx)("div", { className: "info-list-container" }));
        this._addInfoListItem((0, i18n_1.$)("modal.about.version"), (0, global_1.getVersionString)());
        this._addInfoListItem((0, i18n_1.$)("modal.about.repo"), "nocpiun/motive", "https://github.com/nocpiun/motive");
        this._addInfoListItem((0, i18n_1.$)("modal.about.license"), "MPL-2.0 License");
    }
    _addInfoListItem(name, content, link) {
        var _a;
        (_a = this._container.querySelector(".info-list-container")) === null || _a === void 0 ? void 0 : _a.appendChild((0, jsx_runtime_1.jsxs)("div", { className: "info-list-item", children: [(0, jsx_runtime_1.jsx)("span", { className: "info-list-item-name", children: name }), link
                    ? (0, jsx_runtime_1.jsx)("a", { className: "info-list-item-content", href: link, target: "_blank", rel: "noreferrer", children: content })
                    : (0, jsx_runtime_1.jsx)("span", { className: "info-list-item-content", children: content })] }));
    }
}
exports.AboutModal = AboutModal;
